// extracted by mini-css-extract-plugin
module.exports = {"container":"WaypointPinLayer_container__eH5gg","title":"WaypointPinLayer_title__a45o7"};